module.exports = __webpack_public_path__ + "static/media/building2.93c5da33.png";